export enum RemindStatus {
  INACTIVE = 0,
  ACTIVATE,
}
